import { DiceD10OutlineIcon } from './DiceD10OutlineIcon';

/**
 * author: Austin Andrews
 * id 47BB1E5C-0CCD-4A50-B1EF-2437411217C0
 * name dice-d10-outline
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dice-d10-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const DieD10Icon = DiceD10OutlineIcon;
export default DieD10Icon